export default function sanitizeCsv(data) {
    if (data && data.length) {
        const sanitizedData = [];

        for (const row of data) {
            const sanitizedRow = {};

            for (const key in row) {

                // escape quotation marks with doubles
                if (typeof row[key] === 'string')
                    sanitizedRow[key] = row[key].replace(/"/g, '""');
                else
                    sanitizedRow[key] = row[key];
            }

            sanitizedData.push(sanitizedRow);
        }

        return sanitizedData;
    } else return data;
}